import { render, staticRenderFns } from "./EnamelMetalPendant.vue?vue&type=template&id=9aeefd92&scoped=true&"
import script from "./EnamelMetalPendant.vue?vue&type=script&lang=js&"
export * from "./EnamelMetalPendant.vue?vue&type=script&lang=js&"
import style0 from "./EnamelMetalPendant.vue?vue&type=style&index=0&id=9aeefd92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aeefd92",
  null
  
)

component.options.__file = "EnamelMetalPendant.vue"
export default component.exports